export default function Error() {
  return <center>
    <img src="error.svg" alt="Error" width={120} height={120}/>
    <div>Oops! Something went wrong...</div>
  </center>
}
